var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',{staticClass:"section-auth p-tb-25 bg-lighter"},[_c('div',{staticClass:"container-mini"},[_c('div',{staticClass:"text-center m-b-25"},[_c('router-link',{attrs:{"to":{ name: 'home' }}},[_c('img',{staticClass:"h-65",attrs:{"src":require("../../assets/images/logo-color.png"),"alt":"Logo"}})])],1),_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }